import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { T, pick } from "../lib/translations";
import { CITIES } from "../lib/cities";

export default function Footer() {
  const { lang } = useLang();
  return (
    <footer className="bg-[#2C4C3B] text-[#EAE6DF] relative overflow-hidden" data-testid="site-footer">
      <div className="tricolor-band tricolor-band-thick" data-testid="footer-tricolor" style={{ borderRadius: 0 }} />
      <div className="container-x py-20 relative">
        <div className="grid md:grid-cols-4 gap-12">
          <div>
            <img src="/rihai-logo.png" alt="Rihai" className="h-20 w-auto mb-4" data-testid="footer-logo" />
            <p className="text-[#D8CDBA] text-sm leading-relaxed max-w-xs mb-5">
              {pick(T.footer.tag, lang)}
            </p>
            <a
              href={`tel:${T.phone.number}`}
              className="inline-flex items-center gap-2 text-white font-medium border-b border-white/40 pb-1 hover:border-white transition"
              data-testid="footer-call"
            >
              📞 {T.phone.display}
            </a>
          </div>
          <div className="space-y-3 text-sm">
            <div className="overline text-[#D8CDBA]">{lang === "en" ? "Company" : "कंपनी"}</div>
            <Link to="/blog" className="block hover:text-white transition" data-testid="footer-link-guides">
              {lang === "en" ? "Bail Guides" : "ज़मानत गाइड"}
            </Link>
            <Link to="/offenses" className="block hover:text-white transition" data-testid="footer-link-offenses">
              {lang === "en" ? "Bail by Offence" : "अपराध के अनुसार ज़मानत"}
            </Link>
            <a href="/#faq" className="block hover:text-white transition" data-testid="footer-link-faq">{pick(T.nav.faq, lang)}</a>
            <a href="/#lead" className="block hover:text-white transition" data-testid="footer-link-contact">{pick(T.footer.contact, lang)}</a>
          </div>
          <div className="space-y-3 text-sm">
            <div className="overline text-[#D8CDBA]">{lang === "en" ? "Bail Lawyers By City" : "शहर के अनुसार वकील"}</div>
            {Object.values(CITIES).map((c) => (
              <Link
                key={c.slug}
                to={`/${c.slug}`}
                className="block hover:text-white transition"
                data-testid={`footer-city-${c.slug}`}
              >
                {lang === "hi" ? c.cityHindi : c.city}
              </Link>
            ))}
          </div>
          <div className="space-y-3 text-sm">
            <div className="overline text-[#D8CDBA]">{lang === "en" ? "Legal" : "क़ानूनी"}</div>
            <a href="#" className="block hover:text-white transition" data-testid="footer-link-privacy">{pick(T.footer.privacy, lang)}</a>
            <a href="#" className="block hover:text-white transition" data-testid="footer-link-terms">{pick(T.footer.terms, lang)}</a>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-[#3F5D4C] text-xs text-[#B8B1A0]">
          {pick(T.footer.copy, lang)}
        </div>
      </div>
    </footer>
  );
}
